/* unplugin-vue-components disabled */import script from "./Marketing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Marketing.vue?vue&type=script&setup=true&lang=ts"

import "./Marketing.vue?vue&type=style&index=0&id=4b27428c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b27428c"]])

export default __exports__